import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "card-body p-3"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12 table-responsive" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "text-danger fw-bold" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = { class: "col-md-9" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/clientesDocumentosService";
import config from "@/app.config.json";
import { useAcl } from "vue-simple-acl";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

interface IProps {
  ClienteId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesDocumentos',
  props: {
    ClienteId: {}
  },
  setup(__props: any) {


//vue
const acl = useAcl();

//componentes
var props = __props;

  var controle = reactive({
    clienteId: props.ClienteId as number | null | undefined,
    itens: [] as service.Documento[],
    model: {
      clienteId: props.ClienteId
    } as service.UploadArquivo,
    janela: false,
    janPergunta:false,
    erro: "",
    status: ""
  })

  onMounted(() => {
   
    buscarItems();

  });

  watch(() => props.ClienteId, (newValue) => {
    controle.clienteId = newValue;
    controle.model.clienteId = newValue ?? 0;
    buscarItems();
  });

  async function buscarItems() {

      if (!props.ClienteId) {
        controle.itens = [];
        return;
      }

      controle.status = "Buscando items...";
      controle.erro = "";
      service.obter({clienteId: props.ClienteId} as service.Filtros)
      .then((r) => {
        controle.itens = r;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }
      
  async function salvar() {

      controle.status = "Salvando item...";
      controle.erro = "";

      controle.model.clienteId = controle.clienteId ?? 0;
      
      service.uploadDocumento(controle.model)
      .then(() => {
        controle.status = "";
        controle.model = {
          clienteId: controle.model.clienteId,
          tipo: ""
        } as service.UploadArquivo;
        buscarItems();
        controle.janela = false;
      })
      .catch((error) => {
        controle.erro = `Erro ao salvar item: ${error}`;
        controle.status = "";
      });
  }

  function excluir(item: service.Documento) {
    controle.model.documentoId = item.documentoId;
    controle.janPergunta = true;
  }

  function excluirConfirma()
  {
    controle.janPergunta = false;
    controle.status = "Excluindo item...";
    controle.erro = "";

    service.excluir(controle.model.documentoId)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,
        documentoId: 0,
        tipo: "",
        arquivo: new File([], "")
      } as service.UploadArquivo;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Documentos")
          ], -1)),
          (!_unref(props).ClienteId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("p", { class: "" }, "Necessário cadastro do cliente")
                  ])
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).janela = true))
                    }, "Adicionar")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Documento"),
                          _createElementVNode("th", null, "Ações")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(item.tipo), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                class: "btn btn-sm btn-primary me-1",
                                title: "Ver / download",
                                target: "_blank",
                                href: `${_unref(config).urlApi}/documentos/${item.arquivo}`
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-search" }, null, -1)
                              ]))], 8, _hoisted_9),
                              (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-danger",
                                    title: "Excluir registro",
                                    onClick: ($event: any) => (excluir(item))
                                  }, [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                  ]))], 8, _hoisted_10))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(controle).status), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(controle).erro), 1)
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createVNode(MsgBox, {
          id: 'janAddDocto',
          class: "modal-md",
          "data-bs-backdrop": "static",
          exibir: _unref(controle).janela,
          titulo: 'Cadastro de Documento',
          onOnFechou: _cache[3] || (_cache[3] = ($event: any) => (_unref(controle).janela = false)),
          "botao-gravar": true,
          "botao-fechar": true,
          onOnGravar: _cache[4] || (_cache[4] = ($event: any) => (salvar()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-3" }, " Tipo ", -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.tipo) = $event)),
                  class: "form-select form-select-sm"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: null }, "- Selecione - ", -1),
                  _createElementVNode("option", { value: "cpf" }, "CPF", -1),
                  _createElementVNode("option", { value: "rg" }, "RG", -1),
                  _createElementVNode("option", { value: "cnh" }, "CNH", -1),
                  _createElementVNode("option", { value: "certidaoCasamento" }, "Certidão de Casamento", -1),
                  _createElementVNode("option", { value: "certidaoNascimento" }, "Certidão de Nascimento", -1),
                  _createElementVNode("option", { value: "comprovanteResidencia" }, "Comprovante Residência", -1),
                  _createElementVNode("option", { value: "fotoPessoal" }, "Foto Pessoal", -1)
                ]))], 512), [
                  [_vModelSelect, _unref(controle).model.tipo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-3" }, " Documento ", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control form-control-sm",
                  onChange: _cache[2] || (_cache[2] = (e) => _unref(controle).model.arquivo = (e.target as HTMLInputElement).files ? (e.target as HTMLInputElement).files[0] : null)
                }, null, 32)
              ])
            ])
          ]),
          _: 1
        }, 8, ["exibir"])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janExcluirDocto',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[5] || (_cache[5] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[6] || (_cache[6] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})